module.exports = __webpack_public_path__ + "static/media/Inter-Regular.77812e2f.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-Regular.woff2
// module id = 702
// module chunks = 21